/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-21 17:58:28
 * @FilePath: \heshan_web\src\api\admin\role.js
 */
import request from '@/router/axios';
export function fetchList(query) {
  return request({
    url: '/api/blade-system/role/page',
    method: 'get',
    params: query
  });
}
export function fetchroleList(query) {
  return request({
    url: '/api/blade-system/role/page',
    method: 'get',
    params: query
  });
}
export function deptRoleList() {
  return request({
    url: '/api/blade-system/role/tree',
    method: 'get'
  });
}
export function getObj(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  });
}
export function addObj(obj) {
  return request({
    url: '/api/blade-system/role/submit',
    method: 'post',
    data: obj
  });
}
export function putObj(obj) {
  return request({
    url: '/api/blade-system/role/submit',
    method: 'post',
    data: obj
  });
}
export function delObj(obj) {
  return request({
    url: '/api/blade-system/role/remove',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: obj
  });
}
export function fetchRoleTree(roleName) {
  return request({
    url: '/admin/menu/tree/' + roleName,
    method: 'get'
  });
}
export function getAllMenu() {
  return request({
    url: '/api/blade-system/menu/grant-tree',
    method: 'get'
  });
}
export var getRole = function getRole(roleIds) {
  return request({
    url: '/api/blade-system/menu/role-tree-keys',
    method: 'get',
    params: {
      roleIds: roleIds
    }
  });
};
export function getRoleMenu(roleId) {
  return request({
    url: '/admin/menu/tree/' + roleId,
    method: 'get'
  });
}
/**
 * @param {Number} roleId
 * @param {String} menuIds
 */

export function setRoleMenu(roleId, menuIds) {
  return request({
    url: 'api/blade-system/role/grant',
    method: 'post',
    data: {
      roleId: roleId,
      menuIds: menuIds,
      apiScopeIds: [],
      dataScopeIds: []
    }
  });
}